import { localizedUrlWithQueryParams } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { useSearchPageEscapeHatchPrefix } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageEscapeHatchPrefix";
import { useSearchPageSpellCorrectedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageRequestId } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { getCurrentPath } from "@faire/web/common/Path";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { trackSearchSpellcheckqueryclickClick } from "@faire/web-api--source/events/search/click/spellcheckqueryclick";
import productSearchPath from "@faire/web-api--source/routes/www/search";
import React, { useEffect, useRef } from "react";

export const SearchPageSpellCheckEscapeHatch = () => {
  const loading = useSearchPageQueryIsLoading();
  const searchString = useSearchPageProductSearchString();
  const requestId = useSearchPageRequestId();
  const isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
  const escapeHatchPrefix = useSearchPageEscapeHatchPrefix();
  const spellCorrectedQuery = useSearchPageSpellCorrectedQuery();
  const prevSearchStringRef = useRef(searchString);

  useEffect(() => {
    if (!loading) {
      prevSearchStringRef.current = searchString;
    }
  }, [searchString, loading]);

  const linkPath = isFromDiscoverURL
    ? localizedUrlWithQueryParams(
        productSearchPath({ q: searchString || "" }),
        { doQuerySpellCheck: "" }
      )
    : getCurrentPath().append({ doQuerySpellCheck: "" }).toString();

  return (
    <>
      {escapeHatchPrefix}
      <EmbeddedLink
        linkTo={linkPath}
        onClick={() =>
          trackSearchSpellcheckqueryclickClick(
            spellCorrectedQuery ?? "",
            searchString,
            requestId ?? ""
          )
        }
      >
        {/* Show the previous search string if the query is loading because the spellcheck query is not yet available for the search query */}
        {loading ? prevSearchStringRef.current : searchString}
      </EmbeddedLink>
    </>
  );
};
